module.exports = __webpack_public_path__ + "assets/img/button.75d4a502.png";